export default function<T>(initialData: MaybeRef<T>, currentData: Ref<T>) {
  const normalize = (_key: string, value: any) => {
    // Important for data that should be treated as undefined to avoid false positives
    if (value === '' || (Array.isArray(value) && value.length === 0) || value === false || value === null) {
      return undefined
    }
    return value
  }

  const initialSnapshot = computed(() => JSON.stringify(unref(initialData), normalize))

  const isDirty = computed(() => {
    const currentSnapshot = JSON.stringify(currentData.value, normalize)
    return currentSnapshot !== initialSnapshot.value
  })

  return { isDirty }
}
